var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{style:({'filter':_vm.filter}),attrs:{"src":"https://www.lefisc.com.br/reclef/img/Revisor da Exclusão do ICMS do PISCOFINS_Prancheta 1.png","alt":"reclef"}})])}
var staticRenderFns = []

export { render, staticRenderFns }